'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _SharedTrip = require('./SharedTrip.scss');

var _SharedTrip2 = _interopRequireDefault(_SharedTrip);

var _Link = require('components/Link/Link');

var _Link2 = _interopRequireDefault(_Link);

var _reactIntl = require('react-intl');

var _RatingPoint = require('components/General/RatingPoint/RatingPoint');

var _RatingPoint2 = _interopRequireDefault(_RatingPoint);

var _media = require('utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SharedTrip: {
    displayName: 'SharedTrip'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Trip/SharedTrip.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var SharedTrip = _wrapComponent('SharedTrip')((_dec = (0, _reactCssModules2.default)(_SharedTrip2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SharedTrip, _Component);

  function SharedTrip(props) {
    (0, _classCallCheck3.default)(this, SharedTrip);
    return (0, _possibleConstructorReturn3.default)(this, (SharedTrip.__proto__ || (0, _getPrototypeOf2.default)(SharedTrip)).call(this, props));
  }
  // onClick() {
  //   this.props.onClick();
  // }


  (0, _createClass3.default)(SharedTrip, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          trip = _props.trip,
          prices = _props.prices,
          currency = _props.currency;

      return _react3.default.createElement(
        _Link2.default,
        { to: '/trip/' + trip.slug },
        _react3.default.createElement(
          'div',
          { styleName: 'main-container' },
          _react3.default.createElement(
            'div',
            { styleName: 'trip-image', style: trip.cover_image && (0, _media.path)(trip.cover_image, 'coverTripCard', true) },
            trip.user_id && trip.user_id.rating && trip.user_id.rating.average_rating > 0 && _react3.default.createElement(_RatingPoint2.default, { point: trip.user_id.rating.average_rating })
          ),
          _react3.default.createElement(
            'div',
            { styleName: 'trip-content' },
            _react3.default.createElement(
              'h3',
              { styleName: 'trip-name' },
              trip.name
            ),
            _react3.default.createElement(
              'div',
              { styleName: 'trip-prices' },
              trip.discount_percentage > 0 && _react3.default.createElement(
                'div',
                { styleName: 'discount-percent-container' },
                _react3.default.createElement(
                  'p',
                  { styleName: 'discount-percent' },
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.item.discount', values: { percent: trip.discount_percentage * 100 + '%', lineBreak: _react3.default.createElement('br', null) } })
                )
              ),
              _react3.default.createElement(
                'div',
                { styleName: 'price-container' },
                trip.discount_percentage > 0 && _react3.default.createElement(
                  'span',
                  { styleName: 'discount-price' },
                  currency,
                  ' ',
                  prices.displaySeasonedPrice
                ),
                _react3.default.createElement(
                  'span',
                  { styleName: 'sale-price' },
                  currency,
                  ' ',
                  prices.displayPrice
                )
              )
            ),
            _react3.default.createElement(
              'p',
              { styleName: 'per-person' },
              _react3.default.createElement(_reactIntl.FormattedMessage, { id: trip.is_per_day === true ? 'trip.item.per_day' : 'trip.item.per_person' })
            )
          )
        )
      );
    }
  }]);
  return SharedTrip;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  prices: _react2.PropTypes.object,
  currency: _react2.PropTypes.string
}, _temp)) || _class));

exports.default = SharedTrip;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Trip/SharedTrip.js
// module id = 134
// module chunks = 1 2 9 13 14 24